module.exports = __webpack_public_path__ + "img/lg_ring_r_s_null_1.b7b0564c.png";